import React from 'react'
import styled from 'styled-components'
import ReactSelect from 'react-select'
import { device } from '../../../atoms/Utlis/media'

export const gradient = 'linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%)'

export const JOB_TYPES = [
  'Camera Man',
  'Studio Manager',
  'Studio Owner',
  'Traditional photographer',
  'Cinematographer',
  'Candid photographer',
  'Helper',
  'Drone operator',
] as const

export const EMPLOYMENT_TYPES = ['Full Time', 'Part Time', 'Freelancer'] as const

export function getFormProgress(fields: {
  name: string
  jobType: string
  contact: string
  countryCode: string
  hasPhoto?: boolean
}) {
  let done = 0
  const total = 5
  if (fields.name.length >= 2) done += 1
  if (fields.jobType.length > 0 && fields.jobType !== 'Job Type') done += 1
  if (/^[0-9]{10}$/.test(fields.contact)) done += 1
  if (fields.countryCode.length > 0 && fields.countryCode.length <= 4) done += 1
  if (fields.hasPhoto) done += 1
  return Math.round((done / total) * 100)
}

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100dvh - 90px);
  flex: 1;
  min-height: 0;
  padding: 24px;
  font-family: Urbanist, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
  box-sizing: border-box;
  @media ${device.tablet} { padding: 16px; }
`

export const Hero = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  overflow: visible;
  flex-shrink: 0;
  border-radius: 20px;
  padding: 22px 24px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(53, 183, 200, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);
`

export const HeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -60px;
  right: -4%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 201, 81, 0.28) 0%, transparent 70%);
`

export const HeroRow = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`

export const HeroLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
`

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  color: rgba(23, 23, 23, 0.72);
  flex-shrink: 0;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.25);
    color: #c94daa;
    transform: translateY(-1px);
  }
`

export const HeroText = styled.div`
  min-width: 0;
`

export const HeroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(201, 77, 170, 0.14);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c94daa;
`

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.25;
  padding: 2px 0;
`

export const PageSubtitle = styled.p`
  margin: 0px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.62);
  max-width: 480px;
`

export const ProgressWrap = styled.div`
  min-width: 180px;
  flex-shrink: 0;
`

export const ProgressLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.55);
`

export const ProgressPct = styled.span`
  color: #c94daa;
  font-weight: 700;
`

export const ProgressTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(201, 77, 170, 0.12);
  overflow: hidden;
`

export const ProgressFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${(p) => p.$pct}%;
  border-radius: 999px;
  background: ${gradient};
  transition: width 0.35s ease;
`

export const ProgressHint = styled.p`
  margin: 8px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
  text-align: right;
`

export const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 4px;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
  @media ${device.laptop} { grid-template-columns: 1fr; }
`

export const FormCard = styled.div`
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 10px 32px rgba(23, 23, 23, 0.06);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CardIcon = styled.div<{ $tone?: string }>`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => p.$tone || '#c94daa'};
  background: ${(p) => `${p.$tone || '#c94daa'}14`};
`

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #171717;
`

export const CardSubtitle = styled.p`
  margin: 2px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`

export const PhotoUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 28px 20px;
  border-radius: 18px;
  border: 2px dashed rgba(201, 77, 170, 0.28);
  background: linear-gradient(180deg, rgba(201, 77, 170, 0.04) 0%, rgba(255, 201, 81, 0.04) 100%);
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.5);
    background: linear-gradient(180deg, rgba(201, 77, 170, 0.07) 0%, rgba(255, 201, 81, 0.06) 100%);
    transform: translateY(-1px);
  }
`

export const PhotoRing = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
`

export const MemberImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  background: #e2e8f0;
  border: 4px solid #fff;
  box-shadow: 0 8px 24px rgba(201, 77, 170, 0.2);
`

export const PhotoBadge = styled.div`
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${gradient};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.35);
  border: 3px solid #fff;
`

export const PhotoHint = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #c94daa;
  text-align: center;
`

export const PhotoSubhint = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
  text-align: center;
`

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 600px) { grid-template-columns: 1fr; }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldFull = styled(Field)`
  grid-column: 1 / -1;
`

export const Label = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export { FormLabelIcon, FormGradientDefs } from './FormLabelIcon'

export const RequiredStar = styled.span`
  color: #e44862;
  margin-left: 2px;
`

export const FieldHint = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.4);
`

export const Input = styled.input`
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 12px;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 600;
  padding: 0 16px;
  color: #171717;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  &:focus {
    outline: none;
    border-color: rgba(201, 77, 170, 0.4);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
    background: #fff;
  }
  &::placeholder {
    color: rgba(23, 23, 23, 0.35);
    font-weight: 500;
  }
`

const memberSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '48px',
    borderRadius: '12px',
    borderColor: state.isFocused ? 'rgba(201, 77, 170, 0.45)' : 'rgba(23, 23, 23, 0.1)',
    background: state.isFocused ? '#ffffff' : '#fafafa',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(201, 77, 170, 0.1)' : 'none',
    fontFamily: 'Urbanist, sans-serif',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
    '&:hover': {
      borderColor: 'rgba(201, 77, 170, 0.32)',
      background: '#ffffff',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 14px',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: 'rgba(23, 23, 23, 0.35)',
    fontWeight: 500,
  }),
  singleValue: (base: any) => ({
    ...base,
    color: '#171717',
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    color: state.isFocused ? '#c94daa' : 'rgba(23, 23, 23, 0.45)',
    padding: '0 14px 0 8px',
    transition: 'transform 0.15s ease, color 0.15s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    '&:hover': {
      color: '#c94daa',
    },
  }),
  menu: (base: any) => ({
    ...base,
    marginTop: '8px',
    borderRadius: '16px',
    padding: '8px',
    border: '1px solid rgba(201, 77, 170, 0.12)',
    boxShadow: '0 20px 44px rgba(23, 23, 23, 0.14)',
    overflow: 'hidden',
    zIndex: 9999,
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base: any, state: any) => ({
    ...base,
    borderRadius: '12px',
    padding: '12px 14px',
    fontFamily: 'Urbanist, sans-serif',
    fontSize: '15px',
    fontWeight: state.isSelected ? 700 : 600,
    color: state.isSelected ? '#171717' : '#171717',
    background: state.isSelected
      ? 'linear-gradient(135deg, rgba(255, 201, 81, 0.2), rgba(201, 77, 170, 0.14))'
      : state.isFocused
        ? 'rgba(201, 77, 170, 0.08)'
        : '#ffffff',
    cursor: 'pointer',
    '&:active': {
      background: 'rgba(201, 77, 170, 0.14)',
    },
  }),
}

type SelectProps = {
  id?: string
  name?: string
  value: string | number
  onChange: (e: { target: { value: string } }) => void
  children: React.ReactNode
  disabled?: boolean
  style?: React.CSSProperties
  className?: string
}

export const Select: React.FC<SelectProps> = ({ id, name, value, onChange, children, disabled, style, className }) => {
  const options: Array<{ value: string; label: React.ReactNode; isDisabled?: boolean }> = []

  React.Children.forEach(children, (child) => {
    if (React.isValidElement<any>(child) && child.type === 'option') {
      options.push({
        value: String(child.props.value),
        label: child.props.children,
        isDisabled: child.props.disabled,
      })
    } else if (Array.isArray(child)) {
      child.forEach((nestedChild) => {
        if (React.isValidElement<any>(nestedChild) && nestedChild.type === 'option') {
          options.push({
            value: String(nestedChild.props.value),
            label: nestedChild.props.children,
            isDisabled: nestedChild.props.disabled,
          })
        }
      })
    }
  })

  const selectedOption = options.find((option) => option.value === String(value)) ?? null
  const placeholderOption = options.find((option) => option.isDisabled)

  return React.createElement(ReactSelect, {
    inputId: id,
    name,
    value: selectedOption,
    onChange: (option: any) => onChange({ target: { value: option?.value ?? '' } }),
    options: options.filter((option) => !option.isDisabled),
    placeholder: placeholderOption ? String(placeholderOption.label) : 'Select an option',
    menuPosition: 'fixed',
    menuPortalTarget: document.body,
    isSearchable: false,
    isDisabled: disabled,
    className,
    styles: {
      ...memberSelectStyles,
      container: (base: any) => ({
        ...base,
        ...(style || {}),
      }),
    },
  })
}

export const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  height: 48px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:focus-within {
    border-color: rgba(201, 77, 170, 0.4);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
    background: #fff;
  }
`

export const CountryCodeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border-right: 1px solid rgba(23, 23, 23, 0.08);
  flex-shrink: 0;
`

export const CountryCodeInput = styled.input`
  width: 48px;
  border: none;
  background: transparent;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #171717;
  &:focus { outline: none; }
`

export const PhoneInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  background: transparent;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 600;
  padding: 0 16px;
  color: #171717;
  &:focus { outline: none; }
  &::placeholder {
    color: rgba(23, 23, 23, 0.35);
    font-weight: 500;
  }
`

export const ErrorSpan = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #e44862;
`

export const SubmitBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 18px 22px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 201, 81, 0.08) 0%, rgba(206, 86, 176, 0.06) 100%);
  border: 1px solid rgba(201, 77, 170, 0.12);
`

export const SubmitHint = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.55);
  max-width: 320px;
`

export const SubmitButton = styled.button<{ $ready?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 160px;
  height: 48px;
  padding: 0 28px;
  border: none;
  border-radius: 12px;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: ${(p) => (p.$ready ? 'pointer' : 'not-allowed')};
  background: ${(p) => (p.$ready ? gradient : 'rgba(23, 23, 23, 0.12)')};
  color: ${(p) => (p.$ready ? '#fff' : 'rgba(23, 23, 23, 0.4)')};
  box-shadow: ${(p) => (p.$ready ? '0 8px 20px rgba(201, 77, 170, 0.28)' : 'none')};
  transition: all 0.15s ease;
  &:hover {
    transform: ${(p) => (p.$ready ? 'translateY(-1px)' : 'none')};
    box-shadow: ${(p) => (p.$ready ? '0 10px 24px rgba(201, 77, 170, 0.32)' : 'none')};
  }
`

export const DeleteBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid rgba(228, 72, 98, 0.25);
  background: rgba(228, 72, 98, 0.06);
  color: #e44862;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: rgba(228, 72, 98, 0.12);
  }
`
